import { Table, message, Button, Row, Col, Pagination, Image, Select, Space, Badge, Input } from "antd";
import { EditOutlined, PlusOutlined, ShoppingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";
import { FormatVND } from "../../../utils/format";
import { getAllCategoryIndex, updateCategoryIndex, updatePinned } from "../../../api/category";

export default function ProductManage() {
  const [product, setProduct] = useState([]);
  const [categoryIndex, setCategoryIndex] = useState([]);
  const [searchDraft, setSearchDraft] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  const applySearch = (value) => {
    setSearchKeyword(String(value || "").trim());
    setPagination(prev => ({ ...prev, page: 1 }));
  };
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchProduct = async () => {
    await axiosInstance.get(`/product/getAll`, {params: {...pagination, keyword: searchKeyword}})
      .then((res) => {
        const data = res?.data;
        setProduct(data);
      })
      .catch(() => message.error("Error server!"));
  };

  const columns = [
    {
      title: <div>ID</div>,
      key: "product_id",
      dataIndex: "product_id",
      width: 100,
      sorter: (a, b) => a.product_id - b.product_id,
      render: (_, record) => <div>{record?.product_id}</div>,
    },
    {
      title: <div>Tên</div>,
      key: "product_name",
      dataIndex: "product_name",
      width: 150,
      render: (_, record) => <div>{record?.product_name}</div>,
    },
    {
      title: <div>Giá tiền</div>,
      key: "product_price",
      dataIndex: "product_price",
      width: 150,
      render: (_, record) => <div>{FormatVND(record?.product_price)}</div>,
    },
    {
      title: <div>Ảnh</div>,
      key: "product_image",
      dataIndex: "product_image",
      width: 150,
      render: (_, record) => <div><Image src={JSON.parse(record?.product_image)?.filter((i) => i.type === 'image')?.[0]?.data} width={100} height={100}/></div>,
    },
    {
      title: <div>Danh mục con</div>,
      key: "category_child_name",
      dataIndex: "category_child_name",
      width: 150,
      render: (_, record) => <div>{record?.category_child_name}</div>,
    },
    {
      title: <div>Danh mục trang chủ</div>,
      key: "category_index_id",
      dataIndex: "category_index_id",
      width: 150,
      sorter: (a, b) => a.category_index_id - b.category_index_id,
      render: (_, record) => 
        <div>
          <Select
            options={[
              ...categoryIndex?.data?.map(item => ({
                value: item?.category_index_id,
                label: (
                  <div className="flex items-center">
                    <img src={item?.category_index_image} className="w-full h-10" alt={item?.category_index_id} />
                  </div>
                )
              })) || [],
              {
                value: null,
                label: (
                  <div className="flex items-center">
                    <span>None</span>
                  </div>
                )
              }
            ]}
            className="w-[100px]"
            value={record?.category_index_id}
            defaultValue={record?.category_index_id}
            onChange={(selectedOption) => {
              updateCategoryIndex(record?.product_id, selectedOption, message, fetchProduct);
            }}
          />
        </div>,
    },
    {
      title: <div>Ghim</div>,
      key: "pinned",
      dataIndex: "pinned",
      width: 150,
      render: (_, record) => 
        <div>
          <Select
            options={[
              ...Array.from({ length: 15 }, (_, index) => ({
                value: index + 1,
                label: (
                  <div className="flex items-center">
                    <span>{index + 1}</span>
                  </div>
                )
              })),
              {
                value: null,
                label: (
                  <div className="flex items-center">
                    <span>None</span>
                  </div>
                )
              }
            ]}
            className="w-[100px]"
            disabled={record?.category_index_id ? false : true}
            value={record?.category_index_id ? record?.pinned : "None"}
            onChange={(selectedOption) => {
              if(record?.category_index_id) {
                updatePinned(record?.product_id, record?.category_index_id, selectedOption, message, fetchProduct);
              } else {
                message.info("Bạn vui lòng chọn danh mục trang chủ trước khi chọn ghim!")
              }
            }}
          />
        </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">SEO Title</div>,
      key: "product_title_seo",
      dataIndex: "product_title_seo",
      width: 200,
      render: (_, record) => <div className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-gray-600 italic">
        {record?.product_title_seo || <span className="text-gray-300 font-normal">Chưa thiết lập</span>}
      </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">SEO Description</div>,
      key: "product_description_seo",
      dataIndex: "product_description_seo",
      width: 250,
      render: (_, record) => <div className="max-w-[250px] overflow-hidden text-ellipsis line-clamp-2 text-gray-500 text-xs">
        {record?.product_description_seo || <span className="text-gray-300">Nội dung SEO chưa được tối ưu hóa...</span>}
      </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 120,
      sorter: (a, b) => dayjs(a.create_at).unix() - dayjs(b.create_at).unix(),
      render: (date) => <div className="text-[13px] font-medium text-gray-500">{dayjs(date).format("DD/MM/YYYY")}</div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">Trạng thái</div>,
      key: "product_status",
      dataIndex: "product_status",
      width: 120,
      render: (status) => (
        <Badge 
          status={status === 'public' ? 'success' : 'default'} 
          text={status === 'public' ? 'Công khai' : 'Bản nháp'} 
          className="font-medium"
        />
      ),
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 80,
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/admin/quan-ly-san-pham/${record?.product_id}`}>
            <Button 
              type="primary" 
              ghost 
              shape="circle" 
              icon={<EditOutlined />} 
              className="hover:scale-110 transition-transform"
            />
          </Link>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    fetchProduct();
    getAllCategoryIndex(setCategoryIndex);
  }, [pagination, searchKeyword]);

  return (
    <>
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-6 mt-2">
        <Row align="middle" justify="space-between">
          <Col>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                 <ShoppingOutlined className="text-blue-600 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-black text-gray-800 m-0 leading-tight">Quản lý sản phẩm</h1>
                <p className="text-gray-400 text-xs m-0">Danh sách toàn bộ sản phẩm và cấu hình SEO hệ thống</p>
              </div>
            </div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-san-pham/tao-moi"}>
              <Button type="primary" size="large" icon={<PlusOutlined />} className="rounded-xl font-bold h-11 px-8 shadow-lg shadow-blue-100">
                Tạo sản phẩm mới
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 p-4 mb-3">
        <Input.Search
          placeholder="Tìm tên sách hoặc mã sản phẩm trong toàn bộ kho"
          allowClear
          enterButton="Tìm kiếm"
          value={searchDraft}
          onChange={(event) => setSearchDraft(event.target.value)}
          onSearch={applySearch}
          style={{ maxWidth: 550 }}
        />
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={product?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={product?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
